import { render, staticRenderFns } from "./bestScorePage.vue?vue&type=template&id=bfc3dc58&scoped=true&"
import script from "./bestScorePage.vue?vue&type=script&lang=js&"
export * from "./bestScorePage.vue?vue&type=script&lang=js&"
import style0 from "./bestScorePage.vue?vue&type=style&index=0&id=bfc3dc58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc3dc58",
  null
  
)

export default component.exports